import React from 'react'
import { motion } from 'framer-motion';
import { item } from './../../pages/homepage/Section1';
import { GrowthIcon, SecureIcon, SettingIcon } from '../../view/FinanceReco';

const Section4 = ({datas}) => {
  return (
    <div className='s3-fin-reco f-width m-auto'>
        <div className='row w-f-t-c-v'>
            <p className='fs-md'>{datas.heading}</p>
            <motion.div variants={item} whileInView="visible" initial="hidden" transition={{duration: 1}} className="col-lg-4 col-sm-12">
                <img src={SecureIcon} alt='Secure Reliable Automated' />
                <p><strong>{datas.subHead1}:</strong><br/>{datas.p1}</p>
            </motion.div>
            <motion.div variants={item} whileInView="visible" initial="hidden" transition={{duration: 1.5}} className="col-lg-4 col-sm-12">
                <img src={SettingIcon} alt='Fits Into Your Stack' />
                <p><strong>{datas.subHead2}:</strong><br/>{datas.p2}</p>
            </motion.div>
            <motion.div variants={item} whileInView="visible" initial="hidden" transition={{duration: 2}} className="col-lg-4 col-sm-12">
                <img src={GrowthIcon} alt='Built to Scale' />
                <p><strong>{datas.subHead3}:</strong><br/>{datas.p3}</p>
            </motion.div>
        </div>
    </div>
  )
}

export default Section4